import {
    CREATE_GARMENTS_PO_DETAILS_FAILURE,
    CREATE_GARMENTS_PO_DETAILS_REQUEST,
    CREATE_GARMENTS_PO_DETAILS_SUCCESS,
    CREATE_USER_FORM_GARMENTS_PO_DETAILS,
    DELETE_GARMENTS_PO_DETAILS_FAILURE,
    DELETE_GARMENTS_PO_DETAILS_REQUEST,
    DELETE_GARMENTS_PO_DETAILS_SUCCESS,
    FETCH_SINGLE_GARMENTS_PO_DETAILS_FAILURE,
    FETCH_SINGLE_GARMENTS_PO_DETAILS_REQUEST,
    FETCH_SINGLE_GARMENTS_PO_DETAILS_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_FAILURE,
    FETCH_GARMENTS_PO_DETAILS_REQUEST,
    FETCH_GARMENTS_PO_DETAILS_SUCCESS,
    GARMENTS_PO_DETAILS_USERFORM_RESET,
    UPDATE_GARMENTS_PO_DETAILS_FAILURE,
    UPDATE_GARMENTS_PO_DETAILS_REQUEST,
    UPDATE_GARMENTS_PO_DETAILS_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_BY_ID_REQUEST,
    FETCH_GARMENTS_PO_DETAILS_BY_ID_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_BY_ID_FAILURE,
    FETCH_GARMENTS_PO_PREVIOUS_LIST_REQUEST,
    FETCH_GARMENTS_PO_PREVIOUS_LIST_SUCCESS,
    FETCH_GARMENTS_PO_PREVIOUS_LIST_FAILURE,
    FETCH_GARMENTS_PO_DETAILS_DC_NO_REQUEST,
    FETCH_GARMENTS_PO_DETAILS_DC_NO_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_GARMENTS_PO_NO_REQUEST,
    FETCH_GRN_NO_BY_GARMENTS_PO_NO_SUCCESS,
    FETCH_GRN_NO_BY_GARMENTS_PO_NO_FAILURE,
    FETCH_GARMENTS_PO_PROGRAM_REQUEST,
    FETCH_GARMENTS_PO_PROGRAM_SUCCESS,
    FETCH_GARMENTS_PO_PROGRAM_FAILURE,
    FETCH_GARMENTS_PO_DETAIL_STYLE_REQUEST,
    FETCH_GARMENTS_PO_DETAIL_STYLE_SUCCESS,
    FETCH_GARMENTS_PO_DETAIL_STYLE_FAILURE,
    FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_REQUEST,
    FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_SUCCESS,
    FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_FAILURE,
    CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_REQUEST,
    CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_SUCCESS,
    CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_FAILURE,
    GARMENTS_PO_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET,
    GARMENTS_PO_DETAILS_GENERATE_GRID_FINAL_DATA_SET,
    CREATE_GARMENTS_PO_DETAILS_GRID_REQUEST,
    CREATE_GARMENTS_PO_DETAILS_GRID_SUCCESS,
    CREATE_GARMENTS_PO_DETAILS_GRID_FAILURE,
    RESET_GARMENTS_PO_DETAIL_GENERATE_SKU,
    FETCH_GARMENTS_PO_DETAILS_FORM_REQUEST,
    FETCH_GARMENTS_PO_DETAILS_FORM_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_FORM_FAILURE,
    FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_REQUEST,
    FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_FAILURE,
    CREATE_USER_FORM_GARMENTS_PO_EDIT_QTY,
    GARMENTS_EDITABLE_QUANTITY_VALUE_SUCCESS,
    GARMENTS_EDITABLE_QUANTITY_VALUE_FALIURE,
    GARMENTS_EDITABLE_QUANTITY_VALUE_REQUEST,
    INITAIL_LOADED_GRID_DATA_SIZE,
    GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS,
    GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_REQUEST,
    GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_FALIURE,
    FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_SUCCESS,
    FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_REQUEST,
    FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_FAILURE,
    GARMENTS_PO_PROGRAM_ID_SUCCESS,
    GARMENTS_PO_PROGRAM_ID_REQUEST,
    GARMENTS_PO_PROGRAM_ID_FALIURE,
    GARMENTS_PO_DETAILS_DELETE_FAILURE,
    GARMENTS_PO_DETAILS_DELETE_REQUEST,
    RESET_USER_FORM_TO_DEFAULT,
    FETCH_GARMENTS_PO_DETAILS_BY_ID_RESET,
    GET_GARMENTPO_WITH_ACC_REQUEST,
    GET_GARMENTPO_WITH_ACC_SUCCESS,
    GET_GARMENTPO_WITH_ACC_FAILURE,
    CREATE_USER_FORM_GARMENTPO_WITH_ACC_GENERATE_QTY,
    GARMENTPO_WITH_ACC_SUCCESS,
    RESET_TO_GARMENTPO_ACC_PERVIOUS_LIST

} from './garmentsPoDetails.actionsType';

export const GARMENTS_PO_DETAILS = 'garmentsPoDetails';

let initialState = {
    loading: false,
    garmentsPODetailsById: [],
    garmentsPODetailsByInnerGrid: [],
    garmentsPODetailsForm: [],
    garmentsPODetails: [],
    garmentsPODetailsDcNo: [],
    previousList: [],
    garmentsPODetailsSizeGrid: [],
    grnNoByGarmentsPONo: [],
    garmentsPOProgram: [],
    output: [],
    finalData: [],
    garmentsPODetailStyle: [],
    generateSKUStyleGarmentsPODetails: [],
    userform: {
        fldFKRatePerPCs: 0,
        // fldFKSKUDetail: [],
        fldQuantity: 0,
        fldFKNoofRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKSKUDetail: []
    },
    selectedGarmentsPODetails: {},
    errorMessage: '',
    iperrorMessage: '',
    editableDcQty: '',
    garmentsPODetailsSizeGridInitial: [],
    garmentsPOEditQty: [],
    garmentAccessoriesGridData: []
};

export let garmentsPODetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    if (type === 'FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_SUCCESS') {
        localStorage.setItem('garmentsPODetailsSizeGridInitial', JSON.stringify(updatePayload));
    }


    switch (type) {
        case FETCH_GARMENTS_PO_DETAILS_REQUEST:
        case FETCH_GARMENTS_PO_DETAILS_FORM_REQUEST:
        case FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_REQUEST:
        case FETCH_GARMENTS_PO_PROGRAM_REQUEST:
        case FETCH_GARMENTS_PO_DETAIL_STYLE_REQUEST:
        case FETCH_GRN_NO_BY_GARMENTS_PO_NO_REQUEST:
        case FETCH_GARMENTS_PO_DETAILS_DC_NO_REQUEST:
        case FETCH_GARMENTS_PO_PREVIOUS_LIST_REQUEST:
        case FETCH_GARMENTS_PO_DETAILS_BY_ID_REQUEST:
        case CREATE_GARMENTS_PO_DETAILS_REQUEST:
        case CREATE_GARMENTS_PO_DETAILS_GRID_REQUEST:
        case CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_REQUEST:
        case FETCH_SINGLE_GARMENTS_PO_DETAILS_REQUEST:
        case UPDATE_GARMENTS_PO_DETAILS_REQUEST:
        case DELETE_GARMENTS_PO_DETAILS_REQUEST:
        case FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_REQUEST:
        case GARMENTS_EDITABLE_QUANTITY_VALUE_REQUEST:
        case GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_REQUEST:
        case FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_REQUEST:
        //case GARMENTS_PO_PROGRAM_ID_REQUEST:
        case GARMENTS_PO_DETAILS_DELETE_REQUEST:
        case GET_GARMENTPO_WITH_ACC_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GARMENTS_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetails: updatePayload
            };
        case FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetailsSizeGrid: updatePayload.Program
            };
        case CREATE_USER_FORM_GARMENTS_PO_EDIT_QTY:
            return {
                ...state,
                loading: false,
                garmentsPODetailsSizeGrid: payload
            };
        case INITAIL_LOADED_GRID_DATA_SIZE:
            return {
                ...state,
                loading: false,
                garmentsPODetailsSizeGridInitial: payload
            }

        case FETCH_GARMENTS_PO_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetailsForm: updatePayload
            };
        case FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generateSKUStyleGarmentsPODetails: updatePayload
            };
        case FETCH_GARMENTS_PO_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPOProgram: updatePayload?.Program
            };
        case FETCH_GARMENTS_PO_DETAIL_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetailStyle: updatePayload?.CUD
            };
        case FETCH_GRN_NO_BY_GARMENTS_PO_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByGarmentsPONo: updatePayload?.Inward
            };
        case GARMENTS_EDITABLE_QUANTITY_VALUE_SUCCESS:
            return {
                ...state,
                loading: false,
                editableDcQty: updatePayload

            }

        case FETCH_GARMENTS_PO_DETAILS_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                garmentsPODetailsById: [],
                errorMessage: updatePayload
            };

        case GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPOEditQty: updatePayload?.Program

            };

        case FETCH_GARMENTS_PO_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetailsDcNo: updatePayload?.CUD
            };
        case FETCH_GARMENTS_PO_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case FETCH_GARMENTS_PO_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetailsById: updatePayload
            };
        case FETCH_GARMENTS_PO_DETAILS_BY_ID_RESET:
            return {
                ...state,
                loading: false,
                garmentsPODetailsById: []


            }
        case FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPODetailsByInnerGrid: updatePayload
            }


        case CREATE_GARMENTS_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                generateSKUStyleGarmentsPODetails: []
            };
        case GARMENTPO_WITH_ACC_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentAccessoriesGridData: updatePayload

            };
        case CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case GARMENTS_PO_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram

            }
        case GARMENTS_PO_PROGRAM_ID_FALIURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case GARMENTS_PO_PROGRAM_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GET_GARMENTPO_WITH_ACC_SUCCESS:
            return {
                ...state,
                loading: false,
                // accessoriesGetListGarment: updatePayload?.ACD
                accessoriesGetListGarment: updatePayload

            }
        case CREATE_USER_FORM_GARMENTPO_WITH_ACC_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                editGarmenrAccQtyList: payload
                // editAccQtyList: payload?.map((x) => ({ ...x, CurrentIssue: x.availableQty }))
            };
        case RESET_TO_GARMENTPO_ACC_PERVIOUS_LIST:
            return {
                ...state,
                loading: false,
                editGarmenrAccQtyList: []
            }
        case CREATE_GARMENTS_PO_DETAILS_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                generateSKUStyleGarmentsPODetails: []
            };

        case FETCH_SINGLE_GARMENTS_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedGarmentsPODetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_GARMENTS_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedGarmentsPODetails: {},
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                }
            };
        case DELETE_GARMENTS_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedGarmentsPODetails: {}
            };

        case FETCH_GARMENTS_PO_DETAILS_FAILURE:
        case FETCH_GARMENTS_PO_DETAILS_FORM_FAILURE:
        case FETCH_GENERATE_SKU_STYLE_GARMENTS_PO_DETAILS_FAILURE:
        case FETCH_GARMENTS_PO_PROGRAM_FAILURE:
        case FETCH_GARMENTS_PO_DETAIL_STYLE_FAILURE:
        case FETCH_GRN_NO_BY_GARMENTS_PO_NO_FAILURE:
        case FETCH_GARMENTS_PO_DETAILS_DC_NO_FAILURE:
        case FETCH_GARMENTS_PO_PREVIOUS_LIST_FAILURE:
        case FETCH_SINGLE_GARMENTS_PO_DETAILS_FAILURE:
        case CREATE_GARMENTS_PO_DETAILS_FAILURE:
        case CREATE_GARMENTS_PO_DETAILS_GRID_FAILURE:
        case CREATE_GARMENTS_PO_DETAILS_SKU_STYLE_FAILURE:
        case UPDATE_GARMENTS_PO_DETAILS_FAILURE:
        case DELETE_GARMENTS_PO_DETAILS_FAILURE:
        case FETCH_GARMENTS_PO_DETAILS_SIZE_GRID_FAILURE:
        case GARMENTS_EDITABLE_QUANTITY_VALUE_FALIURE:
        case GARMENTS_EDITABLE_INNER_QUANTITY_VALUE_FALIURE:
        case FETCH_GARMENTS_PO_DETAILS_BY_INNER_GRID_FAILURE:
        //case GARMENTS_PO_PROGRAM_ID_FALIURE:
        case GARMENTS_PO_DETAILS_DELETE_FAILURE:
        case GET_GARMENTPO_WITH_ACC_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GARMENTS_PO_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_USER_FORM_TO_DEFAULT:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: [],
                    fldStyleNumber: '',
                    fldSalesOrderNo: '',
                    fldFabricGroup: '',
                    fldFabric: '',
                    fldYarnCounts: '',
                    FldColour: '',
                    fldDia: '',
                    fldReceivingRolls: '',
                    fldQuantity: '',
                    pendingQty: '',
                    fldFinishingGSM: 0
                },
            }
        case GARMENTS_PO_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET:
            return {
                ...state,
                loading: false,
                output: payload
            };
        case GARMENTS_PO_DETAILS_GENERATE_GRID_FINAL_DATA_SET:
            return {
                ...state,
                loading: false,
                finalData: payload
            };
        case RESET_GARMENTS_PO_DETAIL_GENERATE_SKU:
            return {
                ...state,
                loading: false,
                generateSKUStyleGarmentsPODetails: []
            };
        case GARMENTS_PO_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedGarmentsPODetails: {}
            };
        default:
            return state;
    }
};
